const mxTimeZones = [
  'America/Cancun',
  'America/Matamoros',
  'America/Chihuahua',
  'America/Ojinaga',
  'America/Hermosillo',
  'America/Monterrey',
  'America/Merida',
  'America/Bahia_Banderas',
].map((value) => ({
  label: value,
  value: value,
}));

export default mxTimeZones;
